import React, { useEffect, useState, createContext } from "react";
import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { getCurrentUser } from "./components/utils/APIUtils";
import { ACCESS_TOKEN } from "./components/constants/constants";

// const LoginPage = React.lazy(() => import("./components/login/login"));
const LoginPage = React.lazy(() => import("./components/login/login"));
const CreateSIM = React.lazy(() => import("./components/createsim/createsim1"));
const Header = React.lazy(() => import("./components/header/header1"));
const Footer = React.lazy(() => import("./components/footer/footer"));
const Profile = React.lazy(() => import("./components/profile/profile"));
const AdminConfiguration = React.lazy(
  () => import("./components/adminconfiguration/adminconfiguration")
);
const List = React.lazy(() => import("./components/list/list1"));
const EditSIM = React.lazy(() => import("./components/editsim/editsim"));
const EditSIM1 = React.lazy(() => import("./components/editsim/editsim1"));
const EditSIM2 = React.lazy(() => import("./components/editsim/editsim2"));
const SIMView = React.lazy(() => import("./components/simview/simview"));
const DashBoard = React.lazy(() => import("./components/dashboard/dashboard"));
const MyComponent = React.lazy(() => import("./components/utils/displayfile"));
const NestedDashboard = React.lazy(() => import("./components/nesteddashboard/nesteddashboard"));
const TicketingDashboard = React.lazy(() => import("./components/ticketingdashboard/ticketingdashboard"));
const CreateSprint = React.lazy(
  () => import("./components/createsprint/createsprint")
);
const SprintList = React.lazy(
  () => import("./components/sprintlist/sprintlist")
);

const SprintView = React.lazy(
  () => import("./components/sprintview/sprintview")
);
const OAuth2RedirectHandler = React.lazy(
  () => import("./components/redirecthandler/OAuth2RedirectHandler")
);

export const AuthenticatedContext = React.createContext({
  isAuthenticated: false,
  currentUser: null,
});
// export const UserContext = React.createContext(null);
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState<any>(null);

  useEffect(() => {
    if (localStorage.getItem(ACCESS_TOKEN) === null) {
      setIsAuthenticated(false);
    } else {
      setIsAuthenticated(true);
      // getCurrentUser().then((response)=>{
      //   setCurrentUser(response.data);
      // })
    }
  }, []);

  return (
    <>    <RecoilRoot>
      <div className="App">
        {/* <UserContext.Provider value={{
        'isAuthenticated' : isAuthenticated,        
      }}> */}
        <AuthenticatedContext.Provider
          value={{ isAuthenticated: isAuthenticated, currentUser: currentUser }}
        >
          <div className="app-top-box">
            <Header />
          </div>

          <BrowserRouter>
            <Routes>
              {/* <Route
            // index
            path="profile"
            element={
              <React.Suspense fallback={<>...</>}>
                <Profile currentUser={currentUser}/>
              </React.Suspense>
            }
          /> */}

              <Route
                // index
                path="login/:errorCode?"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <LoginPage />
                  </React.Suspense>
                }
              />
              {/* <Route
                // index
                path="list/:listTabIndex?"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <List />
                  </React.Suspense>
                }
              /> */}
              <Route
                // index
                path="profile"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <Profile />
                  </React.Suspense>
                }
              />
              <Route
                // index
                path="createsim/:parentSIMId?"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <CreateSIM />
                  </React.Suspense>
                }
              />
              <Route
                // index
                path="dashboard/:listTabIndexFromURL?"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <DashBoard />
                  </React.Suspense>
                }
              />
              <Route
                // index
                path="adminconfig"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <AdminConfiguration />
                  </React.Suspense>
                }
              />
              {/* <Route
                // index
                path="edit/:simId"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <EditSIM />
                  </React.Suspense>
                }
              /> */}
              <Route
                // index
                path="simview/:simId"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <SIMView />
                  </React.Suspense>
                }
              />
              <Route
                // index
                path="editnew/:simId"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <EditSIM2 />
                  </React.Suspense>
                }
              />
              <Route
                // index
                path="createsprint"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <CreateSprint />
                  </React.Suspense>
                }
              />
              <Route
                // index
                path="sprintlist"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <SprintList />
                  </React.Suspense>
                }
              />
              <Route
                // index
                path="sprintview/:sprintId?"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <SprintView/>
                  </React.Suspense>
                }
              />
              <Route
                // index
                path="viewfile"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <MyComponent />
                  </React.Suspense>
                }
              />
              <Route
                // index
                path="nesteddashboard/:listTabIndexFromURL?"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <NestedDashboard />
                  </React.Suspense>
                }
              />
              <Route
                // index
                path="ticketingdashboard"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <TicketingDashboard />
                  </React.Suspense>
                }
              />
              <Route
                // index
                path="oauth2/redirect"
                element={
                  <React.Suspense fallback={<>...</>}>
                    <OAuth2RedirectHandler />
                  </React.Suspense>
                }
              />
            </Routes>
          </BrowserRouter>
        </AuthenticatedContext.Provider>
        {/* </UserContext.Provider> */}
      </div>
      
      <div>
        <Footer />
      </div>
      </RecoilRoot>
    </>
  );
}

export default App;
